/**
 * Rebuilds flat Stained Glass Supplies deep-dropdowns into tiered flyout markup
 * when server HTML has not yet been updated (flat list + # category links).
 */
(function () {
  var MIN_ITEMS = 15;
  var subcategoryTitles = null;

  function getSubcategoryTitles() {
    if (subcategoryTitles) {
      return subcategoryTitles;
    }

    var nav = document.querySelector('.site-nav[data-menu-subcategory-links]');
    var raw = nav ? nav.getAttribute('data-menu-subcategory-links') : '';

    subcategoryTitles = (raw || 'By Manufacturer,By Fusing Coefficient')
      .split(',')
      .map(function (title) {
        return title.replace(/\s+/g, ' ').trim();
      })
      .filter(Boolean);

    return subcategoryTitles;
  }

  function isSubcategoryTitle(title) {
    return getSubcategoryTitles().indexOf(title) !== -1;
  }

  function applySubcategoryClasses() {
    document
      .querySelectorAll('.site-nav--flyout-panel .site-nav__deep-dropdown-trigger')
      .forEach(function (item) {
        var label = item.querySelector(':scope > .site-nav__dropdown-link--second-level');
        var title = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';

        if (isSubcategoryTitle(title)) {
          item.classList.add('site-nav__deep-dropdown-trigger--sub');
        }
      });
  }

  function isCategoryHeading(anchor) {
    if (!anchor || !anchor.classList.contains('site-nav__dropdown-link')) {
      return false;
    }

    var href = (anchor.getAttribute('href') || '').trim();

    if (href === '#' || href === '') {
      return true;
    }

    if (href.indexOf('#') === href.length - 1 && href.replace(/#+$/, '') === '') {
      return true;
    }

    try {
      var parsed = new URL(href, window.location.origin);
      return parsed.pathname === window.location.pathname && parsed.hash === '#';
    } catch (e) {
      return false;
    }
  }

  function transformPanel(panel) {
    if (!panel || panel.classList.contains('site-nav__deep-dropdown--tiered')) {
      return false;
    }

    if (panel.children.length < MIN_ITEMS) {
      return false;
    }

    var lis = Array.prototype.slice.call(panel.children);
    var hasHeadings = lis.some(function (li) {
      return isCategoryHeading(li.querySelector(':scope > a.site-nav__dropdown-link'));
    });

    if (!hasHeadings) {
      return false;
    }

    var introItems = [];
    var categories = [];
    var currentCategory = null;

    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a.site-nav__dropdown-link');

      if (isCategoryHeading(link)) {
        currentCategory = {
          title: link.textContent.replace(/\s+/g, ' ').trim(),
          links: []
        };
        categories.push(currentCategory);
        return;
      }

      var clone = li.cloneNode(true);

      if (currentCategory) {
        currentCategory.links.push(clone);
      } else {
        introItems.push(clone);
      }
    });

    if (!categories.length) {
      return false;
    }

    panel.innerHTML = '';
    panel.classList.add('site-nav__deep-dropdown--tiered');

    if (introItems.length) {
      var introLi = document.createElement('li');
      introLi.className = 'site-nav__flyout-tiered-intro';

      var introUl = document.createElement('ul');
      introUl.className = 'site-nav__flyout-tiered-intro__links';

      introItems.forEach(function (item) {
        introUl.appendChild(item);
      });

      introLi.appendChild(introUl);
      panel.appendChild(introLi);
    }

    categories.forEach(function (category) {
      var triggerLi = document.createElement('li');
      triggerLi.className = 'site-nav__flyout-tiered-trigger';

      if (isSubcategoryTitle(category.title)) {
        triggerLi.classList.add('site-nav__flyout-tiered-trigger--sub');
      }

      var label = document.createElement('span');
      label.className =
        'site-nav__dropdown-link site-nav__dropdown-link--second-level site-nav__flyout-tiered-trigger__label';
      label.textContent = category.title;
      triggerLi.appendChild(label);

      var categoryPanel = document.createElement('ul');
      categoryPanel.className = 'site-nav__flyout-tiered-panel';

      category.links.forEach(function (linkLi) {
        categoryPanel.appendChild(linkLi);
      });

      triggerLi.appendChild(categoryPanel);
      panel.appendChild(triggerLi);
    });

    return true;
  }

  function transformAll() {
    var panels = document.querySelectorAll(
      '.site-nav--flyout-panel .site-nav__deep-dropdown:not(.site-nav__deep-dropdown--tiered)'
    );

    Array.prototype.forEach.call(panels, transformPanel);
  }

  function init() {
    applySubcategoryClasses();
    transformAll();
    window.requestAnimationFrame(function () {
      applySubcategoryClasses();
      transformAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
